export default {
  FRAME_WEB: "FWB",
  FRAME_WEB_SUBSCRIPTION: "FWS",
  STRIPE: "STR",
  REDSYS: "RED",
  HOLDED: "HDA",
  CONTASOL: "SOL",
  ODOO: "ODO",
  SUBSCRIPTION: "SUB",
};
